var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoboxNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "texteditor/infobox"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5984 6.99844C12.5984 10.0912 10.0912 12.5984 6.99844 12.5984C3.90564 12.5984 1.39844 10.0912 1.39844 6.99844C1.39844 3.90564 3.90564 1.39844 6.99844 1.39844C10.0912 1.39844 12.5984 3.90564 12.5984 6.99844ZM7.62066 4.88288C7.62066 5.22653 7.34208 5.50511 6.99844 5.50511C6.65479 5.50511 6.37622 5.22653 6.37622 4.88288C6.37622 4.53924 6.65479 4.26066 6.99844 4.26066C7.34208 4.26066 7.62066 4.53924 7.62066 4.88288ZM6.77623 6.25177C6.55532 6.25177 6.37623 6.43086 6.37623 6.65177V9.83399C6.37623 10.0549 6.55532 10.234 6.77623 10.234H7.22068C7.44159 10.234 7.62068 10.0549 7.62068 9.83399V6.65177C7.62068 6.43086 7.44159 6.25177 7.22068 6.25177H6.77623Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoboxNode);
export default __webpack_public_path__ + "static/media/infoboxNode.f3dc911f4e333cd8bbfeb8a288f5bff6.svg";
export { ForwardRef as ReactComponent };